import { render } from "./ProcessIndex.vue?vue&type=template&id=5b90a66b&scoped=true"
import script from "./ProcessIndex.vue?vue&type=script&lang=js"
export * from "./ProcessIndex.vue?vue&type=script&lang=js"

import "./ProcessIndex.vue?vue&type=style&index=0&id=5b90a66b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b90a66b"]])

export default __exports__